import { formatCurrency } from '@if/core/utils'
import { MonthlyPayment } from '@src/api/compute-api'
import { CreditApplicationDocument } from '@src/api/credit-api'
import { RadioButtonListOption } from '@src/components/RadioButtonList'
import { RequiredDocument, RequiredDocumentWithStatus } from '@src/types'
import { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { buildRequiredDocumentsWithStatus } from './credit-application-selectors'

export function useRequiredDocumentsWithStatus(
  requiredDocuments: RequiredDocument[] | undefined | null,
  documents: CreditApplicationDocument[] | undefined | null,
): RequiredDocumentWithStatus[] {
  return useMemo(() => {
    return buildRequiredDocumentsWithStatus(requiredDocuments, documents)
  }, [requiredDocuments, documents])
}

export function useTermAmountOptions(monthlyPaymentPerMonths: MonthlyPayment[]): RadioButtonListOption[] {
  const { t } = useTranslation()
  return useMemo(() => {
    const ret: RadioButtonListOption[] = []
    monthlyPaymentPerMonths.forEach((term) => {
      const value: RadioButtonListOption = {
        id: term.term.toString(),
        primaryText: t('loan.loanTermMonths', {
          loanTerm: term.term,
        }),
        secondaryText: (
          <Trans
            i18nKey="loan.estimatedPayments"
            values={{ loanAmount: formatCurrency(term.amountWithoutInsurance) }}
          />
        ),
      }
      ret.push(value)
    })
    return ret
  }, [monthlyPaymentPerMonths, t])
}
